import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { DateProps } from "../../../shared/interfaces/select";
import CheckboxInput from "../checkbox/checkbox";
import "dayjs/locale/pt-br";

export default function DateComponent({ label, value, width, height, onChange, disabled = false, dateToday = false }: DateProps) {
  const [parsedDate, setParsedDate] = useState<Dayjs | null>(null);
  const [isChecked, setIsChecked] = useState(false);
  
  useEffect(() => {
    try {
      if (value) {
        let date: Dayjs;
        
        // Tentar diferentes formatos de data
        if (typeof value === 'string') {
          // Se é ISO string (2026-02-18T03:00:00.000Z)
          if (value.includes('T') || value.includes('Z')) {
            date = dayjs(value);
          }
          // Se é formato de data simples (2026-02-18)
          else if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
            date = dayjs(value);
          }
          // Se é formato datetime (2026-02-18 03:00:00)
          else {
            const dateOnly = value.split(' ')[0];
            date = dayjs(dateOnly);
          }
        } 
        // Se é um objeto Date
        else if (value instanceof Date) {
          date = dayjs(value);
        }
        // Se já é um dayjs object
        else {
          date = dayjs(value);
        }
        
        setParsedDate(date.isValid() ? date : null);
      } else {
        setParsedDate(null);
      }
    } catch (error) {
      setParsedDate(null);
    }

    setIsChecked(false);
  }, [value, label]);

  const onChangeCheckbox = (value: boolean) => {
    setIsChecked(value);
    const dateParsedCheckbox = dayjs();
    
    if(value) {
      setParsedDate(dateParsedCheckbox);
      onChange?.(dateParsedCheckbox.toISOString());
    } else {
      setParsedDate(null);
      onChange?.(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DatePicker
        sx={{
          width: width || 300,
          height: height || 55,
          backgroundColor: "#fff",
          pointerEvents: disabled ? "none" : "auto", 
          opacity: disabled ? 0.5 : 1 
        }}
        disabled={disabled}
        format="DD/MM/YYYY"
        label={label}
        value={parsedDate}
        onChange={(newValue: Dayjs | null) => {
          console.log('DateComponent - mudança de valor:', newValue?.format(), 'para label:', label);
          
          if (newValue && newValue.isValid()) {
            // Retornar como ISO string para manter consistência
            onChange?.(newValue.toISOString());
          } else {
            onChange?.(null);
          }

          const isToday = newValue ? dayjs().isSame(newValue, 'day') : false;
          setIsChecked(isToday);
        }}
      />
      {dateToday && 
        <CheckboxInput 
          value={isChecked} 
          isChecked={isChecked} 
          onChange={onChangeCheckbox} 
          label={{ inputProps: { 'aria-label': 'Data de hoje' } }} 
        />
      }
    </LocalizationProvider>
  );
}